import { getStorage, setStorage, unsetStorage } from "@helpers/storage";
import { useUserStore } from "@stores/userStore";

function setAdminOverride(val) {
    if (val) {
        // Enable
        unsetStorage("admin.override.enabled");
    } else {
        // Disable
        setStorage("admin.override.enabled", false);
    }
}

function adminOverrideEnabled() {
    const adminOverride = getStorage("admin.override.enabled");

    if (adminOverride === "false") {
        return false;
    }

    return true;
}

// Legacy support
function hasPermission(permission, allow_override = true) {
    const userStore = useUserStore();
    return userStore.can(permission);
}

export { hasPermission, setAdminOverride, adminOverrideEnabled };
